import { eventsApiSlice } from '../../../store/eventApiSlice';

export const extendedApiSlice = eventsApiSlice
  .enhanceEndpoints({})
  .injectEndpoints({
    endpoints: (builder) => ({
      validateOneClick: builder.mutation({
        query: (token) => ({
          url: 'one-click/verify',
          params: { token },
          method: 'POST',
        }),
      }),
    }),
  });

export const { useValidateOneClickMutation } = extendedApiSlice;
